import React from 'react';
import { withRouter } from 'react-router-dom';
import ContentWithNavigationSidebar from 'legacy/layouts/ContentWithNavigationSidebar';
import ContentHeader from 'legacy/containers/ContentHeader';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { checkRpmFeatureEnabled } from 'configs';
import AccessDeniedContent from 'views/components/AccessDeniedContent/AccessDeniedContent';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { getEkgRecording } from 'state/reducers/ekgRecordings/ekgRecordingActions';
import { EKG_RECORDING_REDUCERS } from 'state/reducers/ekgRecordings/ekgRecordingReducers';
import EkgRecording from 'views/components/EkgRecording';
import { getInnerHeight } from 'common/pageUtils';
import {
  BOTTOM_PADDING,
  HEADER_HEIGHT,
  RIGHT_SIDEBAR_WIDTH,
  SCROLLBAR_WIDTH,
} from 'common/constants';
import { calcRowSeconds } from 'common/recording/graphUtilities';
import * as RC from 'common/recording/recordingConstants';
import styles from './EkgRecordingDetails.css';

class EkgRecordingDetails extends React.Component {
  constructor(props) {
    super(props);

    const innerHeight = getInnerHeight();
    const contentHeight = innerHeight - HEADER_HEIGHT - BOTTOM_PADDING;
    const contentWidth = 1180;
    const mainContentWidth = contentWidth - RIGHT_SIDEBAR_WIDTH;

    const MIN_SECONDS = 1;
    const rowSeconds =
      calcRowSeconds(mainContentWidth) > 0
        ? calcRowSeconds(mainContentWidth)
        : MIN_SECONDS;

    const ekgWidth = rowSeconds * RC.PX_PER_SECOND + SCROLLBAR_WIDTH;
    this.state = {
      recordingId: null,
      contentHeight,
      rowSeconds,
      ekgHeight: contentHeight,
      ekgWidth,
      extraWidth: mainContentWidth - ekgWidth,
      inverted: false,
    };
  }

  componentDidMount() {
    const { params } = this.props.match;
    const recordingId = params.recordingId || null;
    this.setState(
      {
        recordingId,
      },
      () => {
        this.props.dispatch(getEkgRecording(recordingId));
      },
    );
  }

  render() {
    const { me, intl } = this.props;
    const recording = this.props[EKG_RECORDING_REDUCERS.EKG_RECORDING];
    if (!checkRpmFeatureEnabled(me)) {
      return (
        <ContentWithNavigationSidebar>
          <div data-page="patient-search" className={styles.patientSearchPage}>
            <AccessDeniedContent
              title={intl.formatMessage({ id: 'search.PageTitle' })}
            />
          </div>
        </ContentWithNavigationSidebar>
      );
    }

    return (
      <ContentWithNavigationSidebar>
        <div
          data-page="ekg-recordng-details"
          className={styles.ekgRecordingDetailsPage}
        >
          <ContentHeader
            showLastRefresh={false}
            text={intl.formatMessage({ id: 'recording.PageTitle' })}
            showAddPatient={false}
            enableBackButton
            me={me}
          />
          <div>
            <div className={styles.recordingContent}>
              <EkgRecording
                recording={recording}
                width={this.state.width}
                height={this.state.height}
                calpulse={this.state.calpulse}
                rowSeconds={this.state.rowSeconds}
                inverted={this.state.inverted}
              />
            </div>
          </div>
        </div>
      </ContentWithNavigationSidebar>
    );
  }
}

EkgRecordingDetails.contextType = UserProfileContext;
const mapStateToProps = state => {
  const { ekgRecordings } = state;
  return {
    [EKG_RECORDING_REDUCERS.EKG_RECORDING]:
      ekgRecordings[EKG_RECORDING_REDUCERS.EKG_RECORDING],
    me: getDataSource(state, DATASOURCES.ME),
  };
};
export default withRouter(
  connect(mapStateToProps)(injectIntl(EkgRecordingDetails)),
);



// WEBPACK FOOTER //
// ./src/views/pages/EkgRecordingDetails/EkgRecordingDetails.jsx